import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background: #ffffff;
  align-items: stretch;

  .green-line {
    width: 120px;
    height: 4px;
    background-color: #198754;
    border-radius: 4px;
  }

  .step-label {
    font-size: 18px;
    font-weight: lighter;
  }

  .btn-success {
    background-color: #0d875e !important;
  }

  .step-actions {
    margin-top: 50px;
    display: flex;
    justify-content: flex-end;
  }

  .regions-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(160px, 1fr));
    column-gap: 28px;
    margin-top: 8px;
  }

  .region-col {
    position: relative;
    padding-left: 0;
  }

  .region-col.with-divider {
    padding-left: 17px;
  }

  .region-col.with-divider::before {
    content: '';
    position: absolute;
    left: 0;
    top: 6px;
    bottom: 6px;
    width: 1px;
    background: #d8d8d8;
  }

  .region-title {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #198754;
    font-weight: 700;
    margin-bottom: 14px;
    font-size: 15px;
  }

  .region-states {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .state-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    margin: 0;
    min-width: 0;
  }

  .region-checkbox,
  .state-checkbox {
    width: 15px;
    height: 22px;
    accent-color: #198754;
    flex: 0 0 auto;
  }

  .state-label {
    line-height: 1.2;
    min-width: 0;
  }

  .goals-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(320px, 1fr));
    gap: 18px 22px;
  }

  .goal-card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 15px;
    border-radius: 12px;
    background: #f6f6f6;
    border: 1px solid transparent;
    cursor: pointer;
  }

  .goal-card.is-checked {
    background: #f5f5f5;
    border-color: #198754;
  }

  .goal-checkbox {
    width: 18px;
    height: 18px;
    accent-color: #198754;
  }

  .goal-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .goal-label {
    font-size: 16px;
    font-weight: 600;
    color: #575757;
  }

  @media (max-width: 768px) {
    flex-direction: column;

    .step-title {
      font-size: 28px;
      line-height: 1.15;
      margin-bottom: 6px;
      font-weight: 700;
    }

    .step-label {
      line-height: 1.25;
      margin-bottom: 10px;
    }

    .green-line {
      width: 140px;
      height: 6px;
      border-radius: 6px;
      margin-top: 10px;
    }

    .step-form {
      margin-top: 22px;
    }

    textarea.form-control {
      border-radius: 10px;
      padding: 16px;
      font-size: 14px;
      min-height: 120px;
    }

    .step-form .d-flex.mb-2.gap-2,
    .scope-buttons {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      width: 100%;
    }

    .step-form .d-flex.mb-2.gap-2 .btn,
    .scope-buttons .btn {
      width: 100%;
      justify-content: center;
      font-size: 16px;
      border-radius: 5px;
      white-space: nowrap;
    }

    .regions-accordion {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 8px;
    }

    .regions-accordion.has-error {
      border: 1px solid #dc3545;
      border-radius: 10px;
      padding: 10px;
    }

    .region-card {
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      background: #fff;
      overflow: hidden;
    }

    .region-card__header {
      width: 100%;
      border: 0;
      background: #ffffff;
      padding: 12px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
    }

    .region-card__left {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
    }

    .region-card__title {
      font-size: 18px;
      font-weight: 700;
      color: #198754;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .region-card__chevron {
      font-size: 22px;
      color: #6b7280;
    }

    .region-card__content {
      padding: 0 12px 12px 12px;
    }

    .states-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px 14px;
      padding-top: 10px;
    }

    .state-item {
      gap: 10px;
      font-size: 16px;
      line-height: 1.15;
    }

    .region-checkbox,
    .state-checkbox {
      width: 20px;
      height: 20px;
      flex: 0 0 20px;
    }

    .state-label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .goals-grid {
      grid-template-columns: 1fr; /* 1 coluna no celular */
      gap: 12px;
    }

    .goal-card {
      padding: 14px;
      gap: 12px;
    }

    .goal-label {
      font-size: 15px;
      line-height: 1.2;
    }

    /* opcional: remove quebra manual do Step3 */
    .step-label br {
      display: none;
    }

    .step-actions {
      margin-top: 26px;
      display: flex;
      justify-content: space-between;
      gap: 12px;
    }

    .step-actions .btn {
      border-radius: 5px;
      font-size: 16px;
    }

    .step-actions .btn-success {
      min-width: 170px;
      border-radius: 5px;
    }
  }
`;

export const Sidebar = styled.aside`
  width: 20vw;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  height: 100vh;

  .company-card {
    background: #e6f7ef;
    border: 1px solid ${(props) => props.theme.$bg_green_register};
    border-radius: 10px;
    padding: 12px;
    font-size: 14px;

    strong {
      display: block;
      font-weight: 600;
    }

    span {
      color: #64748b;
      font-size: 13px;
    }
  }

  .steps {
    list-style: none;
    padding: 0;
    margin: 40px auto;
    width: 220px;

    li {
      font-size: 15px;
      color: #9ca3af;
      margin-bottom: 90px;
      display: flex;
      align-items: flex-start;
      gap: 12px;
      position: relative;
    }

    li span {
      position: relative;
      width: 32px;
      text-align: right;
      font-weight: 500;
    }

    li span::after {
      content: '';
      position: absolute;
      top: 26px;
      right: 50%;
      transform: translateX(50%);
      height: 52px;
      border-left: 1px dashed #d1d5db;
    }

    li:last-child span::after {
      display: none;
    }

    li.active {
      color: ${(props) => props.theme.$bg_green_register};
      font-weight: 600;
    }
  }

  .sidebar-footer img {
    width: 140px;
    text-align: center;
  }

  @media (max-width: 768px) {
    position: static;
    width: 100%;
    height: auto;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;

    padding: 18px 16px 14px 16px;
    justify-content: flex-start;
    gap: 14px;

    .company-card {
      border-radius: 12px;
      padding: 12px;
      text-align: center;
    }

    .steps {
      width: 100%;
      margin: 6px 0 0 0;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
    }

    .steps li {
      flex: 1;
      margin-bottom: 0;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      text-align: center;
    }

    .steps li span {
      width: auto;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: inherit;
    }

    .steps li span::after {
      display: none;
    }

    .steps li::after {
      content: '';
      position: absolute;
      top: 10px;
      left: calc(50% + 14px);
      width: calc(100% - 28px);
      border-top: 1px dashed #d1d5db;
    }

    .steps li:last-child::after {
      display: none;
    }

    .sidebar-footer {
      display: none;
    }
  }
`;

export const Content = styled.main`
  width: 80vw;
  padding: 64px 80px;
  margin-left: 20vw;
  height: 100vh;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
    margin-left: 0;
    height: auto;
    padding: 24px 16px;
    overflow: visible;
  }
`;
